module.exports = __webpack_public_path__ + "static/media/page18_hand.b0a5b095.png";